var POLYFILL_CONSOLE_OUTPUT = 'function ResizeObserver () { [polyfill code] }';

var prettifyConsoleOutput = function prettifyConsoleOutput(fn) {
  Object.defineProperty(fn, 'toString', {
    value: function value() {
      return POLYFILL_CONSOLE_OUTPUT;
    }
  });
  return fn;
};

export { POLYFILL_CONSOLE_OUTPUT, prettifyConsoleOutput };